const LOCAL_PREVIEW = ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
const NETLIFY_PREVIEW = location.hostname.endsWith('.netlify.app');
const DEMO_ENABLED = LOCAL_PREVIEW || NETLIFY_PREVIEW;
const KEY = 'lange.purchase-preview.v1';
const NAMES = ['Ania', 'Lauren', 'Sophie', 'Emma', 'Julia', 'Camille', 'Elena', 'Laura', 'Clara', 'Marta', 'Alice', 'Louise'];
const delay = () => 60000 + Math.floor(Math.random() * 60001);
let memory;
function readState() {
  try {
    const state = JSON.parse(localStorage.getItem(KEY));
    if (Number.isFinite(state?.nextAt) && Number.isInteger(state?.index)) return state;
  } catch {}
  return memory ?? {
    nextAt: Date.now() + delay(),
    index: 0
  };
}
function saveState(state) {
  memory = state;
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {}
}
function start() {
  if (!DEMO_ENABLED || document.querySelector('.lange-purchase-note')) return;
  const note = document.createElement('aside');
  note.className = 'lange-purchase-note';
  note.setAttribute('aria-label', 'Purchase notification preview');
  note.dataset.previewFixture = 'true';
  note.hidden = true;
  note.innerHTML = window.langeResolve(`<div class="lange-purchase-note__photo"></div><div class="lange-purchase-note__copy" role="status" aria-live="polite"></div><button type="button" aria-label="Dismiss purchase notification"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m4 4 8 8M12 4l-8 8"/></svg></button>`);
  document.body.append(note);
  let hideTimer, exitTimer;
  function hide() {
    clearTimeout(hideTimer);
    note.classList.remove('is-visible');
    note.classList.add('is-leaving');
    exitTimer = setTimeout(() => {
      note.hidden = true;
      note.classList.remove('is-leaving');
    }, 600);
  }
  note.querySelector('button').addEventListener('click', hide);
  const barSelector = '.lc-purchase-bar, .lsb-bar';
  function positionNote() {
    let bottom = 20;
    const viewportBottom = window.visualViewport ? Math.min(innerHeight, visualViewport.offsetTop + visualViewport.height) : innerHeight;
    bottom += innerHeight - viewportBottom;
    for (const bar of document.querySelectorAll(barSelector)) {
      const rect = bar.getBoundingClientRect();
      const style = getComputedStyle(bar);
      if (style.display === 'none' || style.visibility === 'hidden' || !rect.height || rect.top >= viewportBottom || rect.bottom <= 0) continue;
      const restingTop = style.position === 'fixed' && Number.isFinite(parseFloat(style.bottom)) ? innerHeight - parseFloat(style.bottom) - rect.height : rect.top;
      bottom = Math.max(bottom, innerHeight - Math.min(rect.top, restingTop) + 16);
    }
    note.style.bottom = `${Math.ceil(bottom)}px`;
  }
  let positionFrame;
  function schedulePosition() {
    if (positionFrame) return;
    positionFrame = requestAnimationFrame(() => {
      positionFrame = null;
      positionNote();
    });
  }
  window.addEventListener('scroll', schedulePosition, {
    passive: true
  });
  window.addEventListener('resize', schedulePosition, {
    passive: true
  });
  window.visualViewport?.addEventListener('resize', schedulePosition, {
    passive: true
  });
  window.visualViewport?.addEventListener('scroll', schedulePosition, {
    passive: true
  });
  const barResize = new ResizeObserver(schedulePosition);
  const observedBars = new WeakSet();
  function observeBars() {
    document.querySelectorAll(barSelector).forEach(bar => {
      if (!observedBars.has(bar)) {
        observedBars.add(bar);
        barResize.observe(bar);
      }
    });
    schedulePosition();
  }
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList')) observeBars();else if (records.some(record => record.target.matches?.(barSelector))) schedulePosition();
  }).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'hidden']
  });
  document.addEventListener('transitionend', event => {
    if (event.target.matches?.(barSelector)) schedulePosition();
  });
  observeBars();
  saveState(readState());
  function isVisible(el) {
    if (el.getAttribute('aria-hidden') === 'true' || !el.getClientRects().length) return false;
    if (typeof el.checkVisibility === 'function') return el.checkVisibility({
      checkOpacity: true,
      checkVisibilityCSS: true
    });
    for (let node = el; node instanceof Element; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    return true;
  }
  function blocked() {
    return document.hidden || [...document.querySelectorAll('.lc-bag-layer.is-open, .lc-mobile-menu.is-open, .routine-overlay, [role="dialog"], [aria-modal="true"]')].some(isVisible);
  }
  function tick() {
    if (blocked()) {
      if (!note.hidden && note.classList.contains('is-visible')) hide();
      return;
    }
    const state = readState();
    if (Date.now() < state.nextAt || !note.hidden) return;
    saveState({
      nextAt: Date.now() + delay(),
      index: state.index + 1
    });
    const name = NAMES[state.index % NAMES.length];
    const custom = state.index % 5 === 4;
    const quantity = [1, 1, 2, 3][state.index % 4];
    const photo = note.querySelector('.lange-purchase-note__photo');
    photo.innerHTML = window.langeResolve(custom ? '<img src="/lange/paris/products/serum-miracle-algo-actif-720.webp" alt="Serum in a custom set"><img src="/lange/paris/products/creme-phyto-active-de-jour-720.webp" alt="Day cream in a custom set">' : '<img src="/lange/paris/campaign/discovery-set-upsell-7ml-240.jpg" alt="The Carat Discovery Set">');
    photo.classList.toggle('is-custom', custom);
    const copy = note.querySelector('.lange-purchase-note__copy');
    copy.replaceChildren();
    const heading = document.createElement('strong');
    heading.textContent = `${name} bought`;
    const product = document.createElement('span');
    product.textContent = custom ? 'A custom-built set' : quantity === 1 ? 'The Carat Discovery Set' : `${quantity} × The Carat Discovery Set`;
    copy.append(heading, product);
    if (NETLIFY_PREVIEW) {
      const label = document.createElement('small');
      label.className = 'lange-purchase-note__preview';
      label.textContent = 'Preview · example purchase';
      copy.append(label);
    }
    positionNote();
    clearTimeout(exitTimer);
    note.hidden = false;
    note.classList.remove('is-leaving');
    requestAnimationFrame(() => note.classList.add('is-visible'));
    hideTimer = setTimeout(hide, 6500);
  }
  setInterval(tick, 1000);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {
  once: true
});else start();